import api from './api';
import { BoitierStatus, PageResponse, Vehicule } from '../types';

export const vehiculeService = {
  getAll: () => api.get<Vehicule[]>('/api/vehicules').then((r) => r.data),
  getPage: (params: { page: number; size: number; q?: string }) =>
    api.get<PageResponse<Vehicule>>('/api/vehicules/page', {
      params: {
        page: params.page,
        size: params.size,
        ...(params.q?.trim() ? { q: params.q.trim() } : {}),
      },
    }).then((r) => r.data),
  getById: (id: number) => api.get<Vehicule>(`/api/vehicules/${id}`).then((r) => r.data),
  getByClient: (clientId: number) =>
    api.get<Vehicule[]>(`/api/vehicules/client/${clientId}`).then((r) => r.data),
  search: (q: string) => api.get<Vehicule[]>('/api/vehicules/search', { params: { q } }).then((r) => r.data),
  getBoitierStatus: (imei: string) =>
    api.get<BoitierStatus>(`/api/vehicules/${encodeURIComponent(imei)}/status`).then((r) => r.data),
};
